import { createAction } from '@ngrx/store';

export const emptyAction = createAction('[UI] Empty Action');
